import $ from "jquery"; // FAQ - accordion layout

$(".js-faq-question").click(function (e) {
  e.preventDefault();
  var $question = $(this);
  var $answer = $question.siblings(".js-faq-answer");
  $question.stop().toggleClass("is-open");
  $answer.stop().slideToggle();
});